var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEnergyOn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    enableBackground: "new 0 0 32 32",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Energy20"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Energy19"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Energy18"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Energy17"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Energy16"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Energy15"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Energy14"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Energy13"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Energy12"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Energy11"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Energy10"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Energy09"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Energy08"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Energy07"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Energy06"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Energy05"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Energy04"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Energy03"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Energy02"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Energy01"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M26.87,12.49l-10,18C16.69,30.81,16.36,31,16,31c-0.08,0-0.17-0.01-0.25-0.03C15.31,30.85,15,30.46,15,30    V19H6c-0.34,0-0.65-0.17-0.84-0.45c-0.18-0.28-0.21-0.64-0.08-0.95l7-16C12.24,1.24,12.6,1,13,1h6c0.33,0,0.64,0.16,0.83,0.44    c0.18,0.27,0.22,0.62,0.1,0.93L16.48,11H26c0.35,0,0.68,0.19,0.86,0.49C27.04,11.8,27.05,12.18,26.87,12.49z",
    fill: "#FFB841"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergyOn);
export default __webpack_public_path__ + "static/media/energy-on.d4861714736c6fcf0eae57e3f7a53196.svg";
export { ForwardRef as ReactComponent };